import React, { useState } from "react";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField, Box, Typography } from "@mui/material";
import frLocale from "date-fns/locale/fr";

const DatePickerCustomized = ({
  label,
  value,
  onChange,
  height = 40,
  labelSize = 15,
  error = null,
  obligatoire = false,
  mainDate = null,
  maxDate = null,
  ...restProps
}) => {
  return (
    <Box>
      <Typography
        gutterBottom
        color="primary"
        style={{
          marginLeft: 7,
          fontSize: `${labelSize}px`,
        }}
      >
        {label} {obligatoire && <span style={{ color: "red" }}>*</span>}
      </Typography>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={frLocale}
      >
        <DatePicker
          value={value}
          mainDate={mainDate}
          maxDate={maxDate}
          onChange={onChange}
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "&:hover > fieldset": {
                border: error ? "1px solid red" : "1px solid gray",
              },
              fieldset: { border: error ? "1px solid red" : "1px solid gray" },
              height: `${height}px`,
              borderRadius: "4px",
              backgroundColor: "#F6F6F6",
              "&.Mui-focused fieldset": {
                border: error ? "1px solid red" : "1px solid gray",
              },
            },
          }}
          renderInput={(params) => <TextField {...params} />}
          {...restProps}
        />
      </LocalizationProvider>
      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default DatePickerCustomized;
